import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../components/directives.module';
import { ViewComponent } from './view.component';

const ROUTES: Routes = [
  {
    path: '',
    component: ViewComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [ViewComponent],
  exports: [ViewComponent],
})
export class ViewModule {}
